import { createFileRoute, Outlet } from '@tanstack/react-router';
import {
  getGetScreeningTracingIndividualQueryKey,
  getScreeningTracingIndividual,
  ScreeningTracingIndividualDetailsDto,
} from '../../../../api/created/screening.ts';
import { queryClient } from '../../../../api/queryClient.ts';

export const Route = createFileRoute('/screening/$screeningId/individuals/$individualId')({
  component: ScreeningIndividualLayout,
  loader: async ({ params: { individualId } }) =>
    await queryClient.ensureQueryData({
      queryKey: getGetScreeningTracingIndividualQueryKey(individualId),
      queryFn: ({ signal }) => getScreeningTracingIndividual(individualId, undefined, signal),
    }),
  staticData: ({ loaderData: individual }: { loaderData: ScreeningTracingIndividualDetailsDto }) => ({
    title: `${individual.firstName} ${individual.lastName}`,
  }),
});

function ScreeningIndividualLayout() {
  return <Outlet />;
}
